import * as type from '../types/validate'

export const performPaymentValidation = payload => {
    return{
        type: type.REQUEST_SUBSCRIPTION_ENROLMENT,
        payload: payload
    }
}

export const resetPaymentValidation = () => {
    return{
        type: type.RESET_SUBSCRIPTION_ENROLMENT
    }
}